module.exports = __webpack_public_path__ + "static/media/ad3.3503fcde.jpg";